import React from "react";
import { Keyboard } from "lucide-react";

function Shortcut({ k, desc }) {
  return (
    <div className="flex items-center gap-2 text-xs">
      <span className="kbd">{k}</span>
      <span className="muted-text">{desc}</span>
    </div>
  );
}

export function KeyboardHelp() {
  return (
    <div className="ccs-card mb-4 flex flex-wrap items-center gap-4 py-3">
      <div className="flex items-center gap-2 muted-text text-xs uppercase tracking-wider">
        <Keyboard size={14} /> Keyboard
      </div>
      <Shortcut k="Tab" desc="Title → Score → next row's Title" />
      <Shortcut k="Enter" desc="save & jump to next score" />
      <Shortcut k="1 / 2 / 3" desc="Placement 1st / 2nd / 3rd" />
      <Shortcut k="H" desc="Highly Commended" />
      <Shortcut k="C" desc="Commended" />
      <Shortcut k="N or 0" desc="None" />
    </div>
  );
}
